module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[111]110.a3bbced.woff2";